export default __webpack_public_path__ + "static/media/rgt-img-1.b5cf0bcf.jpg";